import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TPVServices } from '../../../tpv/services';

/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-tutorial-slide',
  templateUrl: 'tpv-tutorial-slide.html',
})
export class TpvTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public tpvServices: TPVServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_tpv = true;
    this.tpvServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_tpv': this.globals.restaurant.tutorial_tpv,
    }).then(() => {
      this.navCtrl.pop();
    });

  }

  closeLeave() {
    this.globals.restaurant.tutorial_tpv = true;
    this.tpvServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_tpv': this.globals.restaurant.tutorial_tpv,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/tpv-tutorial-slide/tpv-tutorial-slide.ts